<template>
  <div>
    <div class="bd-block">
      <div class="ksdl">
        <div v-for="(data, index) in titleList" :key="'a' + index">
          <!-- 快速登录 -->
          <div class="ks-title">
            {{ data.content.popTitle }}
            <img
              @click="editField(1, index)"
              class="bianji"
              src="https://ossfytp.mustke.com/image/newStyleImages/bianji4.2-1.svg"
            />
          </div>
          <!-- 请正确填写下面信息 -->
          <div class="ks-tips">
            {{ data.content.popSmallTitle }}
            <img
              @click="editField(2, index)"
              class="bianji"
              src="https://ossfytp.mustke.com/image/newStyleImages/bianji4.2-1.svg"
            />
          </div>
          <div class="ks-line"></div>
        </div>
        <!-- 头像 -->
        <div
          v-for="(data, index) in headerList"
          :key="'b' + index"
          class="ziduan-box"
          style="align-items: start"
        >
          <div class="zyjz">
            <div class="max-w" @click="editField(3, index)">
              {{ data.content.headTitle }}：
            </div>
          </div>
          <div
            class=""
            style="
              flex-grow: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
          >
            <div>
              <img
                :src="data.content.imageUrl"
                style="width: 100px; height: 100px"
              />
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;
              "
            >
              <div
                @click="editField(4, index)"
                style="font-size: 24px; color: #666666; font-weight: 400"
              ></div>
            </div>
          </div>
          <div class="zyjz hand">
            <div class="del1" src=""></div>
            <div class="del1" src=""></div>
            <img
              class="del1"
              src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
            />
          </div>
        </div>
        <!-- 列表 -->
        <div v-for="(item, index) in itemList" :key="'c' + index">
          <div class="ziduan-box" v-if="item.content.type === 0">
            <div class="zyjz">
              <div class="max-w" @click="editField(5, index)">
                {{ item.content.label }}：
              </div>
              <img
                @click="editField(5, index)"
                class="bianji"
                src="https://ossfytp.mustke.com/image/newStyleImages/bianji4.2-1.svg"
              />
              <div class="iptBox">
                <input
                  placeholder-class="input-placeholder"
                  @click="editField(5, index)"
                  class="ipt"
                  type="div"
                  :placeholder="'输入' + item.content.label"
                  disabled
                />
                <div @click.stop="editVali(10, index)" style="cursor: pointer">
                  设置
                </div>
              </div>
            </div>
            <div class="zyjz hand">
              <img
                @click="upTr(index)"
                class="del"
                src="https://ossfytp.mustke.com/image/newStyleImages/shangyi4.2-1.svg"
                v-if="index >= 2"
              />
              <img
                class="del"
                src="https://ossfytp.mustke.com/image/newStyleImages/shangyi-gray.svg"
                v-if="index <= 1"
              />

              <img
                @click="downTr(index)"
                class="del"
                src="https://ossfytp.mustke.com/image/newStyleImages/xiayi4.2-1.svg"
                v-if="index > 0"
              />
              <img
                class="del"
                src="https://ossfytp.mustke.com/image/newStyleImages/xiayi-gray.svg"
                v-if="index === 0"
              />

              <img
                @click="delItem(index)"
                class="del1"
                src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                v-if="index > 0"
              />
              <img
                class="del1"
                src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
                v-if="index === 0"
              />
            </div>
          </div>
          <div class="ziduan-box" v-if="item.content.type === 1">
            <div class="zyjz">
              <div class="max-w" @click="editField(5, index)">
                {{ item.content.label }}：
              </div>
              <img
                class="bianji"
                @click="editField(5, index)"
                src="https://ossfytp.mustke.com/image/newStyleImages/bianji4.2-1.svg"
              />
              <div class="ipt-select" @click="editOption(7, index)">
                <div class="total-content">
                  {{ item.content.value.length }}项内容
                </div>
                <div class="xiajiantou icon-xiala"></div>
                <div>编辑</div>
              </div>
            </div>
            <div class="zyjz hand">
              <img
                @click="upTr(index)"
                class="del"
                src="https://ossfytp.mustke.com/image/newStyleImages/shangyi4.2-1.svg"
                v-if="index >= 2"
              />
              <img
                class="del"
                src="https://ossfytp.mustke.com/image/newStyleImages/shangyi-gray.svg"
                v-if="index <= 1"
              />

              <img
                @click="downTr(index)"
                class="del"
                src="https://ossfytp.mustke.com/image/newStyleImages/xiayi4.2-1.svg"
              />
              <img
                @click="delItem(index)"
                class="del1"
                src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
              />
            </div>
          </div>
        </div>
        <div class="hand-add">
          <button @click="addInput">
            <img
              src="@/assets/images/add_green.png"
              style="width: 12px; height: 12px"
            />
            <p style="font-size: 14px; color: #00c755; margin-left: 10px">
              添加文本框
            </p>
          </button>
          <button @click="addOption">
            <img
              src="@/assets/images/add_green.png"
              style="width: 12px; height: 12px"
            />
            <p style="font-size: 14px; color: #00c755; margin-left: 10px">
              添加选项
            </p>
          </button>
        </div>
      </div>
      <PopupInput
        :showDialog="showPopupInput"
        @close="showPopupInput = false"
        @confirm="confirmClick"
        :type="type"
        :aContent="commValue"
      ></PopupInput>
      <!-- <uploadimg :show="this.showUpload" :maxCount="1" :imgs='0' @upload-close="this.showUpload = false" @upload-success="handleUploadComplete"></uploadimg> -->
    </div>
    <div class="btn-div">
      <div class="cancel" @click="cancel">返回</div>
      <div class="save" @click="save">保存</div>
    </div>
    <div class="safe-div"></div>
  </div>

  <!-- <up-modal contentdivAlign="center" :showCancelButton="true" confirmColor="#ffffff" cancelColor="#3A60FF"
		:show="deleteSureShow" title="放弃保存" content='确认放弃对此设置的编辑?'
		:closeOnClickOverlay="true" width="300px" @confirm="abandonClick()" @cancel="abandonCancel()"
		@close="abandonCancel()"></up-modal> -->
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
export default {
  components: {
    PopupInput,
  },
  props: {
    // question: {
    //   type: Object,
    //   default: null
    // },
    // type: {
    //   type: String,
    //   default: 'stem'
    // }
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      titleList: [],
      headerList: [],
      itemList: [],
      show: false,
      showPopupInput: false,
      type: 0,
      commValue: "",
      commType: "",
      commIndex: "",
      showUpload: false,
      baseList: [
        {
          type: 1, // 1题头 2头像 3填空 4下拉
          content: JSON.stringify({
            popTitle: "快速登录",
            popSmallTitle: "请正确填写下面信息",
          }),
        },
        {
          type: 2,
          content: JSON.stringify({
            headTitle: "头像",
            headSmallTitle: "点击上传头像",
            imgUrl:
              "https://ossfastmake.mustke.com/wenjuan/tupian/13-1778757028580.png",
          }),
        },
        {
          type: 3,
          content: JSON.stringify({
            label: "姓名",
            value: "",
            type: 0,
            format: "0",
            unique: false,
          }),
        },
      ],
    };
  },
  created() {
    this.analyzeData(this.list);
  },
  methods: {
    analyzeData(datas) {
      datas.forEach((item) => {
        item.content = JSON.parse(item.content);
        if (item.type === 1) {
          this.titleList.push(item);
        }
        if (item.type === 2) {
          this.headerList.push(item);
        }
        if (item.type === 3 || item.type === 4) {
          this.itemList.push(item);
        }
      });
      console.log(this.titleList, this.headerList, this.itemList);
    },
    addInput() {
      this.itemList.push({
        type: 3,
        content: {
          label: "字段",
          value: "",
          type: 0,
          format: "0",
          unique: false,
        },
      });
    },
    addOption() {
      const newItem = {
        type: 4,
        content: {
          label: "选项",
          value: [],
          type: 1,
        },
      };
      this.$set(this.itemList, this.itemList.length, newItem);
    },
    editField(t, index) {
      console.log("24345666787898900", t, index);

      this.type = 0;
      this.showPopupInput = true;
      this.commType = t;
      this.commIndex = index;
      if (t === 1) {
        this.commValue = this.titleList[this.commIndex].content.popTitle;
      }
      if (t === 2) {
        this.commValue = this.titleList[this.commIndex].content.popSmallTitle;
      }
      if (t === 3) {
        this.commValue = this.headerList[this.commIndex].content.headTitle;
      }
      if (t === 4) {
        this.commValue = this.headerList[this.commIndex].content.headSmallTitle;
      }
      if (t === 5) {
        this.commValue = this.itemList[this.commIndex].content.label;
      }
      if (t === 6) {
        this.commValue = this.itemList[this.commIndex].content.label;
      }
      if (t === 7) {
        this.commValue = this.itemList[this.commIndex].content.value.join("\n");
      }
    },
    editVali(t, index) {
      this.type = 2;
      this.showPopupInput = true;
      this.commType = t;
      this.commIndex = index;
      this.commValue = JSON.stringify(this.itemList[this.commIndex].content);
    },
    editOption(t, index) {
      this.type = 1;
      this.showPopupInput = true;
      this.commType = t;
      this.commIndex = index;
      this.commValue = "";
    },
    confirmClick(event) {
      console.log("event", event, this.commType, this.commIndex);
      this.showPopupInput = false;
      if (this.commType === 1) {
        this.titleList[this.commIndex].content.popTitle = event;
      }
      if (this.commType === 2) {
        this.titleList[this.commIndex].content.popSmallTitle = event;
      }
      if (this.commType === 3) {
        this.headerList[this.commIndex].content.headTitle = event;
      }
      if (this.commType === 4) {
        this.headerList[this.commIndex].content.headSmallTitle = event;
      }
      if (this.commType === 5) {
        this.itemList[this.commIndex].content.label = event;
      }
      if (this.commType === 6) {
        this.itemList[this.commIndex].content.label = event;
      }
      if (this.commType === 7) {
        this.itemList[this.commIndex].content.value = event
          .split("\n")
          .filter((item) => {
            return item !== "";
          });
      }
      if (this.commType === 10) {
        this.itemList[this.commIndex].content.format = JSON.parse(event).format;
        this.itemList[this.commIndex].content.unique = JSON.parse(event).unique;
      }
    },
    handleUploadComplete(res) {
      console.log("res", res);
      console.log("this.commIndex", this.headerList, this.commIndex);
      this.headerList[0].content.imgUrl = res[0];
    },
    delItem(index) {
      if (index === 0) {
        this.$message({
          type: "error",
          message: "第一项不能移动并且不能删除",
          offset: "150",
        });
      } else {
        this.itemList.splice(index, 1);
      }
    },
    upTr(index) {
      // 上移
      if (index === 0) {
        this.$message({
          type: "error",
          message: "第一项不能移动并且不能删除",
          offset: "150",
        });
      } else {
        //在上一项插入该项
        this.itemList.splice(index - 1, 0, this.itemList[index]);
        //删除后一项
        this.itemList.splice(index + 1, 1);
      }
    },
    downTr(index) {
      // 下移
      if (index === 0) {
        this.$message({
          type: "error",
          message: "第一项不能移动并且不能删除",
          offset: "150",
        });
        return false;
      } else if (index === this.itemList.length - 1) {
        this.$message({
          type: "error",
          message: "已经是最后一项",
          offset: "150",
        });
      } else {
        //在下一项插入该项
        this.itemList.splice(index + 2, 0, this.itemList[index]);
        // 删除前一项
        this.itemList.splice(index, 1);
      }
    },
    cancel() {
      this.$emit("custom-cancel");
    },
    save() {
      console.log(
        "this.itemList",
        this.titleList,
        this.headerList,
        this.itemList,
      );
      // return;
      for (let i = 0; i < this.itemList.length; i++) {
        if (
          this.itemList[i].content.type === 1 &&
          this.itemList[i].content.value.length === 0
        ) {
          this.$message({
            type: "error",
            message: this.itemList[i].content.label + "选项不能为空",
            offset: "150",
          });
          return;
        }
      }
      this.submitInfo = [];
      this.titleList.forEach((item) => {
        this.submitInfo.push({
          type: 1,
          content: JSON.stringify(item.content),
        });
      });
      this.headerList.forEach((item) => {
        this.submitInfo.push({
          type: 2,
          content: JSON.stringify(item.content),
        });
      });
      this.itemList.forEach((item) => {
        this.submitInfo.push({
          type: item.type,
          content: JSON.stringify(item.content),
        });
      });
      this.$emit(
        "custom-login",
        JSON.stringify({
          info: this.submitInfo,
          ifCustomLogin: "1",
        }),
      );
    },
  },
};
</script>

<style scoped>
.switch-div {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 0.5px solid #f0f0f0;
  border-radius: 8px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.switch-title {
  height: 11px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  color: #4c4a56;
  line-height: 11px;
  margin-left: 15px;
}

.zbf-icon {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  color: #278af1;
  font-size: 13px;
}

.content {
  width: 100% !important;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #ffffff !important;
}

.bd-block {
  background-color: #f8f8f8;
  margin-bottom: 20px;
  padding: 0 10px 116px 10px;
  box-sizing: border-box;
}

.block-title {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #5b627a;
  font-size: 16px;
  border-bottom: 1px solid #f5f5f5;
  font-weight: 600;
}

.color-list {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.col-item {
  width: 29px;
  height: 29px;
  background: #009c80;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.col-item img {
  height: 17.5px;
  width: 17.5px;
  flex-shrink: 0;
}

.bd-time {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bd-time img {
  width: 15px;
  height: 15px;
  margin-left: 5px;
  position: relative;
  top: 2px;
}

/*两侧上下居中对齐*/
.Align-on-both-sides {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.set-content {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f5f5f5;
  color: #3c3c3c;
}

.peo-num-box input {
  width: 60px;
  height: 25px;
  text-align: center;
  background-color: #f4f4f4;
}

.set-content .tips {
  font-size: 24px;
  color: #a8a8ab;
}

.saveBtnStyle {
  height: 50px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  line-height: 50px;
  color: white;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  background-color: #3dc180;
  text-align: center;
  z-index: 9;
}

.share-box {
  width: 260px;
  height: 210px;
  background: #ffffff;
  border: 1px solid #dadada;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px auto;

  img {
    width: 100%;
    height: 100%;
  }
}

.c-Img {
  width: 120px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #00c755;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #00c755;
  font-size: 7px;
  margin: 0 auto;
}

.bd-block-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.voteTimeBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.timediv {
  color: #278af1 !important;
}

.fill-in {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ksdl {
  /*width: 690px;*/
  box-sizing: border-box;
  padding: 15px 10px;
  border-radius: 7.5px;
  background-color: #ffffff;
  border: 1px solid #dcdde0;
  margin-top: 12.5px;
}

.ks-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #2b2f36;
  margin-bottom: 10px;
}

.ks-title .bianji {
  width: 10px;
  height: 10px;
  margin-left: 10px;
  position: relative;
  top: 2.5px;
  flex-shrink: 0;
  cursor: pointer;
}

.ks-tips {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  text-align: center;
  color: #4a73f8;
  margin-bottom: 15px;
  padding: 0 15px;

  .bianji {
    width: 10px;
    height: 10px;
    margin-left: 5px;
    position: relative;
    top: 2.5px;
    flex-shrink: 0;
    cursor: pointer;
  }
}

.ks-line {
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 15px;
}

.del {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.ziduan-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.zyjz {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ziduan-box .ipt {
}

.iptBox {
  width: 240px;
  height: 44px;
  background: #f4f4f4;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-sizing: border-box;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  input {
    width: 80px;
    padding-left: 20px;
    font-size: 15px;
    text-align: left;
    color: #949eaf;
  }

  div {
    font-size: 13px;
    color: #4a73f8;
    padding-right: 20px;
  }
}

.ziduan-box .hand {
  /* width: 36px; */
  /* margin-left: 5px; */
}

.ziduan-box .bianji {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.ziduan-box .max-w {
  width: 90px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  font-weight: bold;
  text-align: right;
  color: #555555;
  font-size: 16px;
}

.ipt-select {
  width: 240px;
  height: 44px;
  background: #f4f4f4;
  border: 1px solid #dcdde0;
  border-radius: 8px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 15px;
  text-align: left;
  color: #949eaf;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
}

.total-content {
  font-size: 26px;
  color: #2b2f36;
  /*width: 180px;*/
}

.ipt-select div {
  font-size: 13px;
  color: #4a73f8;
}

.xiajiantou {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  font-size: 22px;
  color: #8c8c8c;
}

.hand-add {
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 264px;
    height: 44px;
    background: #ffffff;
    border: 2px solid #00c755;
    border-radius: 40px;
    margin: 20px;
    color: #00c755;
  }
}

.del1 {
  width: 20px;
  height: 20px;
}

.popComm {
  background-color: white;
  border-radius: 20px;
  width: 320px;
  padding-bottom: 30px;
  overflow: hidden;
}

.tishi-title {
  line-height: 100px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  color: #333;

  div {
    color: #4a73f8;
  }
}

.close-xsxq {
  position: absolute;
  right: 10px;
  top: 15px;

  img {
    height: 20px;
    width: 20px;
  }
}

.center-content {
  width: 92%;
  margin: 10px auto;

  textarea {
    width: 100%;
    height: 250px;
    background: #f4f4f4;
    border: 1px solid #dcdde0;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: auto;
  }
}

.center-content {
  width: 92%;
  margin: 10px auto;

  input {
    width: 100%;
    height: 45px;
    background: #f4f4f4;
    border: 1px solid #dcdde0;
    border-radius: 4px;
    box-sizing: border-box;
    padding-left: 10px;
  }
}

.popComm .btn1 {
  width: 210px;
  height: 40px;
  background: #4a73f8;
  border-radius: 45px;
  color: white;
  text-align: center;
  line-height: 40px;
  margin: 0 auto;
}

.after-fill textarea {
  box-sizing: border-box;
  padding: 10px;
  background: #f4f4f4;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  margin: 0 auto;
  width: 100%;
}

.fill-in .block-title {
  border-bottom: 0;
}

.invite-btns {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e4e4e4;

  .qx {
    width: 50%;
    text-align: center;
    line-height: 46px;
    font-size: 15px;
    color: #4a73f8;
  }

  .qd {
    width: 50%;
    text-align: center;
    line-height: 46px;
    font-size: 15px;
    color: #fff;
    background-color: #4a73f8;
  }
}

.title-flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 40px;
    height: 17px;
    margin-left: 5px;
    position: relative;
    top: 1px;
  }
}

.tip-box {
  width: 340px;
  height: 500px;
  background-color: white;
  border-radius: 10px;
  box-sizing: border-box;
  padding-bottom: 20px;

  .closeBox {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 11px;
    top: 15px;

    .closeImg {
      width: 7.5px;
      height: 7.5px;
      position: absolute;
      right: 50%;
      top: 50%;
      -webkit-transform: translate(50%, -50%);
      transform: translate(50%, -50%);
    }
  }
}

.tip-title {
  font-size: 9px;
  font-weight: bold;
  text-align: center;
  color: #2b2f36;
  line-height: 60px;
}

.Supplementary-description {
  font-size: 7px;
  color: #5d6674;
  margin-bottom: 15px;
  text-align: center;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 15px;

  div {
    color: #4a73f8;
  }
}

.scroll-Y-1 {
  width: 94%;
  margin: 0 auto;
  height: 386px;
}

.pop-bg {
  width: 100vw;
  height: 100vh;
  background: rgba(000, 000, 000, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.popComm1 {
  background-color: white;
  border-radius: 10px;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -320px;
}

.popComm2 {
  background-color: white;
  border-radius: 10px;
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -320px;
}

.note-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 320px;
  background: #ffffff;
  border-radius: 8px;
  z-index: 100;
  transform: translate(-50%, -50%);

  .title1 {
    font-size: 9px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #2b2f36;
    padding-top: 20px;
    padding-bottom: 7px;
    border-bottom: 1px solid #e7e7e7;
  }

  .note-info {
    text-align: center;
    margin: 54px auto;
    color: #555556;
    font-size: 16px;
    width: 275px;

    div {
      color: #4a73f8;
      font-weight: 500;
    }
  }
}

.zz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  border-bottom: 1px solid #eee;
  padding-left: 10px;
  padding-right: 10px;

  div {
    color: #555555;
    font-size: 15px;
  }
}

.zz-picker {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  width: 207px;
  height: 88px;
  background: #f4f4f4;
  border-radius: 5px;

  img {
    width: 20px;
    height: 20px;
  }
}

.no-repeat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  height: 80px;
}

.no-title {
  font-size: 7px;
  font-weight: bold;
  text-align: left;
  color: #555555;
}

.no-tips {
  font-size: 13px;
  text-align: left;
  color: #7c838e;
}

.btn-div {
  /* width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 200;
  padding: 12.5px; */
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
}

.cancel {
  /* flex: 1;
  height: 33px;
  line-height: 33px;
  border-radius: 33px;
  border: 1px solid #3a60ff;
  background: #ffffff;
  font-size: 17px;
  color: #3a60ff;
  font-weight: 600;
  text-align: center;
  cursor: pointer; */
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #3a60ff;
  background-color: #ffffff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.save {
  /* flex: 1;
  height: 33px;
  line-height: 33px;
  border-radius: 33px;
  border: 1px solid #3a60ff;
  background: #3a60ff;
  font-size: 17px;
  color: #ffffff;
  font-weight: 600;
  text-align: center;
  margin-left: 10px;
  cursor: pointer; */
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #fff;
  background-color: #3a60ff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.safe-div {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomLogin/CustomLogin.vue